import { createFileRoute, notFound } from "@tanstack/react-router";
import BlogPost from "@/pages/BlogPost";
import { resolveBlogPost, buildBlogPostHead } from "@/lib/seo";

export const Route = createFileRoute("/blog/$slug")({
  loader: ({ params }) => {
    const resolved = resolveBlogPost(params.slug);
    if (!resolved) throw notFound();
    return resolved;
  },
  head: ({ loaderData }) => {
    if (!loaderData) {
      return {
        meta: [
          { title: "Article not found | Marjohn Robillo" },
          { name: "robots", content: "noindex" },
        ],
      };
    }
    return buildBlogPostHead(loaderData);
  },
  component: BlogPost,
});
